import * as firebase from "firebase";

export default {
    state: {
        loading: false,
        successMessage: "",
        errorMessage: "",
        commonTabs: [
            { name: "myWork", routerLink: "myWork", icon: "mdi-briefcase" },
            { name: "downloads", routerLink: "downloads", icon: "mdi-cloud-download" },
            { name: "aboutMe", routerLink: "aboutMe", icon: "mdi-account" },
        ],
        users: [],
        windowWidth: 0,
        scrollY: 0
    },
    getters: {
        commonTabs(state) {
            return state.commonTabs;
        },
        loading(state) {
            return state.loading;
        },
        successMessage(state) {
            return state.successMessage;
        },
        errorMessage(state) {
            return state.errorMessage;
        },
        getAllUsers(state) {
            return state.users;
        },
        getWindowWidth(state) {
            return state.windowWidth;
        },
        getScrollY(state) {
            return state.scrollY;
        }
    },
    mutations: {
        setLoading(state, payload) {
            state.loading = payload;
        },
        setSuccessMessage(state, payload) {
            state.successMessage = payload;
            setTimeout(() => {
                state.successMessage = "";
            }, 5000);
        },
        setErrorMessage(state, payload) {
            state.errorMessage = payload;
            setTimeout(() => {
                state.errorMessage = "";
            }, 5000);
        },
        setWindowWidth(state, payload) {
            state.windowWidth = payload
        },
        setScrollY(state, payload) {
            state.scrollY = payload;
        }
    },
    actions: {
        setSuccessMessage({ commit }, payload) {
            commit("setSuccessMessage", payload);
        },
        setErrorMessage({ commit }, payload) {
            commit("setErrorMessage", payload);
        },
        fetchAllUsersFromDB({ state, commit}) {
            commit("setLoading", true);
            firebase.database().ref("/users/admin/").once("value")
                .then((data) => {
                    const usersData = data.val();
                    state.users = usersData;
                })
                .catch((error) => {
                    commit("setLoading", false);
                    commit("setErrorMessage", error.message);
                })
        },
        updateWindowWidth({commit}, payload) {
            commit("setWindowWidth", payload);
        },
        updateScrollY({commit}, payload) {
            commit("setScrollY", payload);
        }
    },
    modules: {}
}